import {
    Card,
    Form,
    Row,
    Col,
    Input,
    Divider,
    Button,
    message,
    Switch,
    Select,
} from "antd";
import _, { cloneDeep, set } from "lodash";
import { BLOCK_TYPES, DurationPicker } from "../../../common";
import { SlateEditor } from "src/components";
import { AudioGenerateComponent } from "src/modules/worksheet/components/WorksheetEditor/components/Modals/AudioGenerateComponent";
import FigmaStoryEditor from "../../Figma/renderEditor/FigmaStoryEditor";
import { useWorksheetState } from "src/modules/worksheet/components/contexts/WorksheetContext";
import KTWrapper from "src/modules/worksheet/components/custom/KTComponent";
import HelpQuestionFormModal from "./ComponentsEditor/HelpSystem/HelpQuestionFormModal";
import { GLOBAL_GAMIFY_STATE } from "../defaultValue";
import { deepOmit } from "../../ProgressLevel/renderEditor/helper";
import GenerateQuesSummaryFormModal from "src/modules/worksheet/components/custom/GenerateQuesSummaryFormModal";
import AutomateEvaluationAndFeedbackSetup from "src/modules/worksheet/components/custom/AutomateEvaluationAndFeedbackSetup";

const { ALL_IN_ONE } = BLOCK_TYPES;

export const QuestionColumn = (props: any) => {
    const {
        block,
        setBlock,
        setIsEditor,
        mentionsList = [],
        hasMentions,
        disableWrite,
        currentEditor,
        setCurrentEditor,
        isReadOnlyMode,
        worksheet,
        previewData,
        renderLinkSelect,
    } = props;
    const {
        id,
        tmpId,
        data: {
            slug: dataSlug,
            [ALL_IN_ONE]: {
                badge_count: dataBadgeCount,
                no_badge: dataNoBadge,
                logic: { variables = [] } = {},
                dev_remarks = [],
                globalGamifyState = GLOBAL_GAMIFY_STATE.defaultFunction,
                generating_audio_config,
                duration_link,
            } = {},
            other: { description = [], stories = [] } = {},
        },
        backend = {},
    } = block;

    let slug =
        worksheet?.type === "personalized_learning_v4"
            ? backend?.slug || []
            : dataSlug;
    let badge_count =
        worksheet?.type === "personalized_learning_v4"
            ? backend?.badge_count || []
            : dataBadgeCount;
    let no_badge =
        worksheet?.type === "personalized_learning_v4"
            ? backend?.no_badge || false
            : dataNoBadge;

    const { publishedBlocksMap = {} }: any = useWorksheetState();

    const onDurationChange = (duration: number) => {
        const obj = {
            ...block,
            data: { ...block.data, other: { ...block.data.other, duration } },
        };
        setBlock(obj);
    };

    const figmaStoryEditorProps = {
        ...props,
        disableWrite:
            disableWrite ||
            (!block?.id && worksheet?.type !== "personalized_learning_v4"),
        stories,
        storiesPath: [id || block.data?.storiesId, "data", "other", "stories"],
        setStories: (data: any, storiesId: any) => {
            let tmpBlock = _.cloneDeep(block);
            tmpBlock = _.set(tmpBlock, ["data", "other", "stories"], data);
            if (storiesId)
                tmpBlock = _.set(tmpBlock, ["data", "storiesId"], storiesId);
            setBlock(tmpBlock);
        },
        previewData: block?.id
            ? {
                  ...previewData,
                  variant_id: block?.id,
                  block_id: block?.id,
              }
            : null,
    };

    return (
        <Card
            style={{
                borderRadius: "8px",
                height: "85vh",
                border: "1px solid  rgba(0, 0, 0, 0.06)",
                overflow: "auto",
                scrollbarWidth: "none",
                marginLeft: "8px",
                flexGrow: 0,
                width: "100%",
            }}
            bordered={true}
            onClick={() => {
                setIsEditor(false);
            }}
            bodyStyle={{
                padding: "10px",
            }}
        >
            <Row
                style={{
                    width: "100%",
                    border: "1px dashed #808080",
                    margin: "10px auto",
                    padding: "20px",
                }}
                gutter={[20, 20]}
            >
                <Col span={12}>
                    {worksheet?.type === "personalized_learning_v4" &&
                        block?.id && (
                            <Form.Item label="Block Id">
                                <Input.Search
                                    value={block.id}
                                    onChange={() => {}}
                                    enterButton="Copy"
                                    size="small"
                                    onSearch={() => {
                                        message.info(`Copied Id to clipboard!`);
                                        navigator.clipboard.writeText(block.id);
                                    }}
                                />
                            </Form.Item>
                        )}
                    <Form.Item>
                        <Button
                            disabled={disableWrite}
                            type="primary"
                            size="small"
                            onClick={() => {
                                let tmpBlock = deepOmit(block, [
                                    "is_modified",
                                    "changes_list",
                                    "master_block",
                                ]);

                                navigator.clipboard.writeText(
                                    JSON.stringify(tmpBlock),
                                );
                                message.info(`Copied Question to clipboard!`);
                            }}
                        >
                            Copy the Question to Clipboard
                        </Button>
                    </Form.Item>
                    <AutomateEvaluationAndFeedbackSetup
                        block={block}
                        block_id={block?.id}
                        worksheet={worksheet}
                        level_id={previewData.progression_id}
                        setBlock={setBlock}
                    />
                    <GenerateQuesSummaryFormModal
                        block_id={block?.id}
                        worksheet={worksheet}
                        level_id={previewData.progression_id}
                        value={_.get(block, ["data", "other", "block_summary"])}
                        setBlock={(value: any) => {
                            let tmpBlock = _.cloneDeep(block);
                            tmpBlock = _.set(
                                tmpBlock,
                                ["data", "other", "block_summary"],
                                value,
                            );
                            setBlock(tmpBlock);
                        }}
                    />
                </Col>
                <Col span={12}>
                    {worksheet?.type === "personalized_learning_v4" &&
                        block?.id && (
                            <Form.Item label="Published Block Id">
                                {publishedBlocksMap[block.id] ? (
                                    <Input.Search
                                        value={publishedBlocksMap[block.id]}
                                        onChange={() => {}}
                                        enterButton="Copy"
                                        size="small"
                                        onSearch={() => {
                                            message.info(
                                                `Copied Id to clipboard!`,
                                            );
                                            navigator.clipboard.writeText(
                                                block.id,
                                            );
                                        }}
                                    />
                                ) : (
                                    <span>Not published Yet</span>
                                )}
                            </Form.Item>
                        )}
                    <Form.Item label="Slug">
                        <Input
                            value={slug}
                            disabled={disableWrite}
                            onChange={(e) => {
                                const value = e.target.value;
                                let tmpBlock = _.cloneDeep(block);
                                tmpBlock = _.set(
                                    tmpBlock,
                                    worksheet?.type ===
                                        "personalized_learning_v4"
                                        ? ["backend", "slug"]
                                        : ["data", "slug"],
                                    value,
                                );
                                setBlock(tmpBlock);
                            }}
                        />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label="Block type">
                        <Select
                            value={
                                (worksheet?.type === "personalized_learning_v4"
                                    ? block?.backend?.activity_type
                                    : block?.data?.activity_type) || "INHERIT"
                            }
                            onChange={(value) => {
                                let tmpBlock = cloneDeep(block);
                                tmpBlock = set(
                                    tmpBlock,
                                    worksheet?.type ===
                                        "personalized_learning_v4"
                                        ? ["backend", "activity_type"]
                                        : ["data", "activity_type"],
                                    value,
                                );
                                setBlock(tmpBlock);
                            }}
                        >
                            <Select.Option value="INHERIT">
                                Inherit
                            </Select.Option>
                            <Select.Option value="CHALLENGE">
                                Challenge (Yellow star)
                            </Select.Option>
                            <Select.Option value="LEARNING">
                                Learning (Blue star)
                            </Select.Option>
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <HelpQuestionFormModal
                        helpProvider={block?.data?.other?.helpProvider}
                        setHelpProvider={(value: any) => {
                            let tmpBlock = _.cloneDeep(block);
                            tmpBlock = _.set(
                                tmpBlock,
                                ["data", "other", "helpProvider"],
                                value,
                            );
                            setBlock(tmpBlock);
                        }}
                        currentEditor={currentEditor}
                        setCurrentEditor={setCurrentEditor}
                    />
                </Col>
                <Col span={24}>
                    <h3
                        style={{
                            fontWeight: "bold",
                            marginBottom: "10px",
                        }}
                    >
                        Question
                    </h3>
                    <SlateEditor
                        disabled={disableWrite}
                        hasMentions={hasMentions}
                        mentionsList={mentionsList}
                        id={`${id || tmpId}_description`}
                        onChange={(value: any) => {
                            let tmpBlock = _.cloneDeep(block);
                            tmpBlock = _.set(
                                tmpBlock,
                                ["data", "other", "description"],
                                value,
                            );
                            setBlock(tmpBlock);
                        }}
                        isFocused={
                            currentEditor === `${id || tmpId}_description`
                        }
                        setEditor={(id: string) => setCurrentEditor(id)}
                        value={description}
                        placeholder={"Type your description here..."}
                    />
                </Col>
                <Col span={12}>
                    <KTWrapper feature="duration_link">
                        <Form.Item label="Duration Link">
                            {renderLinkSelect &&
                                renderLinkSelect({
                                    style: { width: 200 },
                                    value: duration_link
                                        ?.linked_global_context_variable?.name,
                                    onChange: (value: any) => {
                                        let tmpBlock = _.cloneDeep(block);
                                        tmpBlock = _.set(
                                            tmpBlock,
                                            [
                                                "data",
                                                ALL_IN_ONE,
                                                "duration_link",
                                                "linked_global_context_variable",
                                                "name",
                                            ],
                                            value,
                                        );
                                        setBlock(tmpBlock);
                                    },
                                })}
                        </Form.Item>
                    </KTWrapper>
                </Col>
                <Col span={12}>
                    <h3
                        style={{
                            fontWeight: "bold",
                            marginBottom: "10px",
                        }}
                    >
                        Dev Remarks
                    </h3>
                    <SlateEditor
                        disabled={disableWrite}
                        hasMentions={hasMentions}
                        mentionsList={mentionsList}
                        id={`${id || tmpId}_remarks`}
                        onChange={(value: any) => {
                            let tmpBlock = _.cloneDeep(block);
                            tmpBlock = _.set(
                                tmpBlock,
                                ["data", ALL_IN_ONE, "dev_remarks"],
                                value,
                            );
                            setBlock(tmpBlock);
                        }}
                        isFocused={currentEditor === `${id || tmpId}_remarks`}
                        setEditor={(id: string) => setCurrentEditor(id)}
                        value={dev_remarks}
                        placeholder={"Type here..."}
                        required={false}
                    />
                </Col>
                <Col span={12}>
                    <h3>Background Audio</h3>
                    <AudioGenerateComponent
                        name={"Background Audio"}
                        onSave={(data: any) => {
                            setBlock({
                                ...block,
                                data: {
                                    ...block.data,
                                    other: {
                                        ...block.data.other,
                                        audio: data,
                                    },
                                },
                            });
                        }}
                        disableWrite={isReadOnlyMode}
                        audioData={block?.data?.other?.audio}
                    />
                </Col>
                <Col span={12}>
                    <Row gutter={24}>
                        <Col span={8}>
                            <KTWrapper feature="badge_count">
                                <Form.Item
                                    label="Badge Count"
                                    rules={[{ required: true }]}
                                    validateStatus={
                                        !badge_count || badge_count <= 0
                                            ? "error"
                                            : ""
                                    }
                                    help={
                                        !badge_count || badge_count <= 0
                                            ? "Field cannot be empty"
                                            : ""
                                    }
                                >
                                    <Input
                                        disabled={disableWrite}
                                        value={badge_count}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            let tmpBlock = _.cloneDeep(block);
                                            tmpBlock = _.set(
                                                tmpBlock,
                                                worksheet?.type ===
                                                    "personalized_learning_v4"
                                                    ? ["backend", "badge_count"]
                                                    : [
                                                          "data",
                                                          ALL_IN_ONE,
                                                          "badge_count",
                                                      ],
                                                value,
                                            );
                                            setBlock(tmpBlock);
                                        }}
                                        required
                                        type="number"
                                        placeholder={`Badge Count`}
                                    />
                                </Form.Item>
                            </KTWrapper>
                        </Col>
                        <Col span={16}>
                            <KTWrapper feature="No_badge_required">
                                <Form.Item
                                    label="No badge required?"
                                    rules={[{ required: true }]}
                                >
                                    <Switch
                                        disabled={disableWrite}
                                        checked={no_badge}
                                        onChange={(value) => {
                                            let tmpBlock = _.cloneDeep(block);
                                            tmpBlock = _.set(
                                                tmpBlock,
                                                worksheet?.type ===
                                                    "personalized_learning_v4"
                                                    ? ["backend", "no_badge"]
                                                    : [
                                                          "data",
                                                          ALL_IN_ONE,
                                                          "no_badge",
                                                      ],
                                                value,
                                            );
                                            setBlock(tmpBlock);
                                        }}
                                    />
                                </Form.Item>
                            </KTWrapper>
                        </Col>
                    </Row>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label="Total Lives"
                        rules={[{ required: true }]}
                        validateStatus={
                            !(
                                variables?.find(
                                    (v: { name: string }) =>
                                        v.name === "total_lives",
                                )?.value > 0
                            )
                                ? "error"
                                : ""
                        }
                        help={
                            !(
                                variables?.find(
                                    (v: { name: string }) =>
                                        v.name === "total_lives",
                                )?.value > 0
                            )
                                ? "Field cannot be empty"
                                : ""
                        }
                    >
                        <Input
                            disabled={disableWrite}
                            value={
                                variables?.find(
                                    (v: { name: string }) =>
                                        v.name === "total_lives",
                                )?.value
                            }
                            onChange={(e) => {
                                const value = e.target.value;
                                let tmpBlock = _.cloneDeep(block);
                                let idx = variables?.findIndex(
                                    (v: { name: string }) =>
                                        v.name === "total_lives",
                                );
                                if (idx >= 0) {
                                    tmpBlock = _.set(
                                        tmpBlock,
                                        [
                                            "data",
                                            ALL_IN_ONE,
                                            "logic",
                                            "variables",
                                            idx,
                                            "value",
                                        ],
                                        value,
                                    );
                                } else {
                                    tmpBlock = _.set(
                                        tmpBlock,
                                        [
                                            "data",
                                            ALL_IN_ONE,
                                            "logic",
                                            "variables",
                                            variables?.length,
                                        ],
                                        {
                                            name: "total_lives",
                                            objectType: "NUMBER",
                                            value,
                                        },
                                    );
                                }
                                setBlock(tmpBlock);
                            }}
                            required
                            type="number"
                            placeholder={`Total Lives`}
                        />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label="Max possible stars">
                        <Input
                            disabled={disableWrite}
                            value={block?.backend?.max_stars || 1}
                            onChange={(e) => {
                                const value = e.target.value;
                                let tmpBlock = _.cloneDeep(block);
                                tmpBlock = _.set(
                                    tmpBlock,
                                    ["backend", "max_stars"],
                                    Number(value),
                                );
                                setBlock(tmpBlock);
                            }}
                            type="number"
                            placeholder={`Max possible stars`}
                        />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <KTWrapper feature="reset_on_try_again">
                        <Form.Item
                            label="Reset on try again?"
                            rules={[{ required: true }]}
                        >
                            <Switch
                                disabled={disableWrite}
                                checked={
                                    variables?.find(
                                        (v: { name: string }) =>
                                            v.name === "is_reset",
                                    )?.value
                                }
                                onChange={(value) => {
                                    let tmpBlock = _.cloneDeep(block);
                                    let idx = variables?.findIndex(
                                        (v: { name: string }) =>
                                            v.name === "is_reset",
                                    );
                                    if (idx >= 0) {
                                        tmpBlock = _.set(
                                            tmpBlock,
                                            [
                                                "data",
                                                ALL_IN_ONE,
                                                "logic",
                                                "variables",
                                                idx,
                                                "value",
                                            ],
                                            value,
                                        );
                                    } else {
                                        tmpBlock = _.set(
                                            tmpBlock,
                                            [
                                                "data",
                                                ALL_IN_ONE,
                                                "logic",
                                                "variables",
                                                variables?.length,
                                            ],
                                            {
                                                name: "is_reset",
                                                objectType: "BOOLEAN",
                                                value,
                                            },
                                        );
                                    }
                                    setBlock(tmpBlock);
                                }}
                            />
                        </Form.Item>
                    </KTWrapper>
                </Col>
                <Col span={8}>
                    <KTWrapper feature="Set_block">
                        <Form.Item label="Set">
                            <Select
                                value={
                                    block?.data?.all_in_one?.logic?.sets || []
                                }
                                mode="multiple"
                                onChange={(value) => {
                                    let tmpBlock = _.cloneDeep(block);
                                    _.set(
                                        tmpBlock,
                                        ["data", "all_in_one", "logic", "sets"],
                                        value,
                                    );
                                    setBlock(tmpBlock);
                                }}
                            >
                                {[
                                    ...Array(
                                        parseInt(
                                            worksheet?.level_settings
                                                ?.number_of_sets ?? 0,
                                        ),
                                    ),
                                ].map((v, i) => {
                                    return (
                                        <Select.Option value={i + 1} key={i}>
                                            {i + 1}
                                        </Select.Option>
                                    );
                                })}
                            </Select>
                        </Form.Item>
                    </KTWrapper>
                </Col>
                <Col span={24}>
                    <h3>Generating Audio Config</h3>
                </Col>
                <Col span={8}>
                    <Form.Item
                        label={"Audio"}
                        labelCol={{
                            span: 24,
                        }}
                    >
                        <AudioGenerateComponent
                            onSave={(data: any) => {
                                let tmpBlock = _.cloneDeep(block);
                                tmpBlock = _.set(
                                    tmpBlock,
                                    [
                                        "data",
                                        ALL_IN_ONE,
                                        "generating_audio_config",
                                        "audio",
                                    ],
                                    data,
                                );
                                setBlock(tmpBlock);
                            }}
                            disableWrite={isReadOnlyMode}
                            audioData={generating_audio_config?.audio}
                        />
                    </Form.Item>
                </Col>
                <Col span={16}>
                    <h3>Feedback</h3>
                    <KTWrapper feature="feedback_duration">
                        <Form.Item label={"Duration"}>
                            <Input
                                type="number"
                                disabled={disableWrite}
                                value={
                                    generating_audio_config?.feedback?.duration
                                }
                                placeholder="Type here..."
                                onChange={(e) => {
                                    let value = e.target.value;
                                    let tmpBlock = _.cloneDeep(block);
                                    tmpBlock = _.set(
                                        tmpBlock,
                                        [
                                            "data",
                                            ALL_IN_ONE,
                                            "generating_audio_config",
                                            "feedback",
                                            "duration",
                                        ],
                                        value,
                                    );
                                    setBlock(tmpBlock);
                                }}
                            />
                        </Form.Item>
                    </KTWrapper>
                    <Form.Item label={"Text"}>
                        <SlateEditor
                            disabled={disableWrite}
                            hasMentions={hasMentions}
                            mentionsList={mentionsList}
                            id={`feedbackIdx_figma`}
                            onChange={(value: any) => {
                                let tmpBlock = _.cloneDeep(block);
                                tmpBlock = _.set(
                                    tmpBlock,
                                    [
                                        "data",
                                        ALL_IN_ONE,
                                        "generating_audio_config",
                                        "feedback",
                                        "text",
                                    ],
                                    value,
                                );
                                setBlock(tmpBlock);
                            }}
                            isFocused={currentEditor === `feedbackIdx_figma`}
                            setEditor={(id: string) => setCurrentEditor(id)}
                            value={
                                generating_audio_config?.feedback?.text || ""
                            }
                            placeholder={"Type here..."}
                        />
                    </Form.Item>
                </Col>
                <Col span={4}>
                    <h3>Duration</h3>
                    <KTWrapper feature="duration-is_timed">
                        <DurationPicker
                            disabled={disableWrite}
                            onChange={onDurationChange}
                            initialValue={block?.data?.other?.duration || 0}
                        />
                    </KTWrapper>
                </Col>
                <Divider />
                <Col span={24}>
                    <Form.Item
                        label={<h2>Global Gamify State</h2>}
                        labelCol={{
                            span: 24,
                        }}
                    >
                        <Input.TextArea
                            disabled={disableWrite}
                            value={globalGamifyState}
                            placeholder="Paste Global State Here"
                            onChange={(value: any) => {
                                let tmpBlock = _.cloneDeep(block);
                                tmpBlock = _.set(
                                    tmpBlock,
                                    ["data", ALL_IN_ONE, "globalGamifyState"],
                                    value.target.value,
                                );
                                setBlock(tmpBlock);
                            }}
                            rows={2}
                        />
                    </Form.Item>
                </Col>

                <Col span={24}>
                    <Form.Item
                        label={<h2>Stories</h2>}
                        labelCol={{
                            span: 24,
                        }}
                    >
                        <FigmaStoryEditor {...figmaStoryEditorProps} />
                    </Form.Item>
                </Col>
            </Row>
        </Card>
    );
};
